import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=5833e2a0&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"
import style0 from "./Sort.vue?vue&type=style&index=0&id=5833e2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5833e2a0",
  null
  
)

export default component.exports